// Dependencies
import Vue from 'vue'
import VueRouter from 'vue-router'
import hooks from './hooks'

// Components
import Home from '../layout/Home/Home'
import Login from '../layout/Login/Login'
import LoginKo from '../layout/LoginKo/LoginKo'
import Admin from '../layout/Admin/Admin'
import NotFound from '../layout/NotFound/NotFound'
import PublicHolidays from '../components/PublicHolidays/PublicHolidays'

Vue.use(VueRouter)

const ROUTER = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login-ko',
      name: 'LoginKo',
      component: LoginKo
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      isDefault: true,
      meta: { requireAuth: true }
    },
    {
      path: '/admin',
      component: Admin,
      redirect: { name: 'publicHolidays' },
      meta: {
        requireAuth: true,
        requireAdmin: true
      },
      children: [
        {
          path: 'public-holidays',
          name: 'publicHolidays',
          component: PublicHolidays
        }
      ]
    },
    {
      path: '/not-found',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      redirect: { name: '404' }
    }
  ]
})

hooks(ROUTER)

export default ROUTER



// WEBPACK FOOTER //
// ./src/router/index.js